(function() {
  "use strict";

  angular.module("sempraWebapp").filter("removeAfterDot", removeAfterDot);

  /** @ngInject */
  function removeAfterDot() {
    return function(text) {
      if (!text) {
        return 0.00
      }
      var splitedString = text.split(".");

      if (!text || splitedString[1] !== "0") return text;

      return splitedString[0];
    };
  }
})();
